module.exports = __webpack_public_path__ + "img/fpay-theme-dark.95761c30.png";